import { useThemeOptional } from "../../design/theme/ThemeProvider";
import MeetBrandMark from "./MeetBrandMark";
import TRABrandWordmark from "./TRABrandWordmark";
import styles from "./brandLockup.module.css";

const SIZES = {
  sm: { icon: 18, gap: 7 },
  md: { icon: 22, gap: 9 },
  /** Platform AppShell header — canonical prominence */
  /** Platform shell — louder than md so brand reads clearly in the fixed header */
  header: { icon: 30, gap: 10 },
  lg: { icon: 34, gap: 12 },
};

/**
 * Horizontal primary lockup (Meet icon + wordmark).
 * @param {{ className?: string; size?: 'sm' | 'md' | 'header' | 'lg'; variant?: 'light' | 'dark' | 'auto' }} props
 */
export default function TRABrandLockup({
  className = "",
  size = "md",
  variant = "auto",
}) {
  const themeCtx = useThemeOptional();
  const resolved =
    variant === "auto"
      ? themeCtx?.resolvedThemeId === "dark"
        ? "dark"
        : "light"
      : variant;

  const dim = SIZES[size] || SIZES.md;
  const sizeKey = size === "header" ? "Header" : `${size.charAt(0).toUpperCase()}${size.slice(1)}`;
  const sizeClass = styles[`lockup${sizeKey}`] || styles.lockupMd;
  const onDark = resolved === "dark";

  return (
    <div
      className={`tra-brand-lockup ${styles.lockup} ${sizeClass}${onDark ? ` ${styles.lockupOnDark}` : ""}${className ? ` ${className}` : ""}`}
    >
      <MeetBrandMark size={dim.icon} variant={resolved} className={styles.icon} />
      <TRABrandWordmark />
    </div>
  );
}
